// Interface

import util from '@/utils/classToObject'
import { IAdminMissionState } from './state'
import { AloDbMission } from '@/models/alodb/AloDbMission'
import { toNumberDictionary } from '@/utils/groupBy'

export class AdminMissionGetter {  
      
  public adminMissions(state:IAdminMissionState,getters:any) {
    return state.adminMissions
  }

  public adminMissionsById(state:IAdminMissionState) {
    return toNumberDictionary(state.adminMissions,i => i.MIS_ID!)
  }  

  public modifiedAdmAdminMission(state:IAdminMissionState,getters:any) {
    return state.modifiedAdmAdminMission
  }

  public originalAdmAdminMission(state:IAdminMissionState,getters:any) {
    return state.originalAdmAdminMission
  }

  public modifiedAdmAdminMissionRolesMapping(state:IAdminMissionState,getters:any) {
    return state.modifiedAdmAdminMissionRolesMapping
  }

  public adminMissionLoading(state:IAdminMissionState,getters:any) {
    return state.adminMissionLoading
  }

  public adminMissionRoleMappingLoading(state:IAdminMissionState,getters:any) {
    return state.adminMissionRoleMappingLoading
  }
  
  public adminMissionStatus(state:IAdminMissionState) {     
    return state.status
  }

  public adminAdminMissionFilter(state:IAdminMissionState) {     
    return state.adminFilter
  }
  
}

export default util.classToObject(AdminMissionGetter)